<template>
  <div class="window window-edit-payment-cashbox" v-show="isVisible">
    <span class="close" title="Закрыть" @click="closeWindow"><img src="../image/cancel.svg"></span>
    <div class="window-title">Редактировать операцию</div>
    <div class="form">
      <div class="form-block">
        <div class="fieldset">
          <label class="fieldset-title">Дата операции</label>
          <date-picker
              v-model="date"
              ref="datePicker"
              format="DD.MM.YYYY"
              lang="ru"
              v-mask="'##.##.####'"
              placeholder="__.__.____"
              :clearable="false"
              :first-day-of-week="1">
          </date-picker>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Время</label>
          <fieldset>
            <input type="time" v-model="time">
          </fieldset>
        </div>
        <div class="fieldset" v-if="showWorker">
          <label class="fieldset-title">ФИО рабочего</label>
          <fieldset>
            <input type="text" disabled :value="workerFullName"/>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Тип операции</label>
          <fieldset>
            <template v-if="['account_deposit', 'account_withdrawal'].indexOf(selectedOperationTypeCode) != -1">
              <select v-model="selectedOperationTypeCode">
                <option v-for="operationType in workerOperationTypes"
                        :value="operationType.code">{{ operationType.name }}
                </option>
              </select>
            </template>
            <template v-else-if="['cashbox_deposit', 'cashbox_withdrawal'].indexOf(selectedOperationTypeCode) != -1">
              <select v-model="selectedOperationTypeCode">
                <option v-for="operationType in nonWorkerOperationTypes"
                        :value="operationType.code">{{ operationType.name }}
                </option>
              </select>
            </template>
            <template v-else-if="!!operation && !!operation.type">
              <input type="text" disabled :value="operation.type.name">
            </template>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Способ расчета</label>
          <fieldset>
            <select v-model="isCash">
              <option :value="true">Наличный</option>
              <option :value="false">Безналичный</option>
            </select>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Комментарий</label>
          <fieldset>
            <input type="text" v-model="comment"/>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Сумма, руб.</label>
          <fieldset>
            <input type="text" v-model="amount"/>
          </fieldset>
        </div>
      </div>
      <div class="buttons">
        <button type="button" class="cancel-button" @click="closeWindow">Отмена</button>
        <button type="button" class="save-button" @click="editOperation">Сохранить изменения</button>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import DatePicker from 'vue2-datepicker'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'

  export default {
    name: 'CashboxEditOperation',
    components: {
      DatePicker
    },

    directives: {mask},

    props: ['isVisible', 'operation'],
    data() {
      return {
        date: null,
        time: null,
        selectedOperationTypeCode: null,
        isCash: true,
        amount: null,
        comment: ''
      }
    },

    computed: {
      waitingApiRequestsCount() {
        return this.$store.getters.waitingApiRequestsCount
      },

      // Справочник типов операций
      operationTypes() {
        return this.$store.getters.cashboxOperationTypes
      },

      workerOperationTypes() {
        return this.operationTypes
            .filter(type => ['account_deposit', 'account_withdrawal'].indexOf(type.code) != -1);
      },

      nonWorkerOperationTypes() {
        return this.operationTypes
            .filter(type => ['cashbox_deposit', 'cashbox_withdrawal'].indexOf(type.code) != -1);
      },

      showWorker() {
        return !!this.operation && !!this.operation.worker;
      },

      workerFullName() {
        if (!this.showWorker)
          return;

        let worker = this.operation.worker;
        return utils.getFullName(worker.name, worker.surname, worker.patronymic);
      }
    },

    watch: {
      isVisible(val) {
        if (val) {
          this.clearData()
        }
      },

      operation(o) {
        if (!o)
          return;

        let date = new Date(o.date);
        this.date = utils.getDateWithoutTime(date);
        this.time = utils.formatTime(date);
        this.selectedOperationTypeCode = o.type.code;
        this.isCash = o.cash;
        this.amount = o.amount;
        this.comment = o.comment;
      }
    },

    methods: {
      clearData() {
        this.date = null;
        this.time = null;
        this.selectedOperationTypeCode = null;
        this.isCash = true;
        this.amount = null;
        this.comment = '';
      },

      editOperation() {
        if (this.waitingApiRequestsCount != 0) {
          return
        }

        if (!this.date || !this.time) {
          alert('Заполните дату и время!');
          return
        }
        let amountNumber = Number(Number(('' + this.amount).replace(',', '.')).toFixed(2));
        if (!amountNumber || amountNumber <= 0) {
          alert('Укажите корректную сумму!');
          return
        }

        let year = this.date.getFullYear();
        let month = this.date.getMonth();
        let day = this.date.getDate();
        let timeAsArray = this.time.split(':');
        let hours = timeAsArray[0];
        let minutes = timeAsArray[1];

        let dto = {
          id: this.operation.id,
          date: new Date(year, month, day, hours, minutes).getTime(),
          type: {
            code: this.selectedOperationTypeCode
          },
          cash: this.isCash,
          amount: amountNumber,
          comment: this.comment
        };

        api
            .editCashboxOperation(dto)
            .then(() => {
              this.$emit('operation-edited');
              this.clearData();
              alert('Операция была изменена');
              this.closeWindow()
            })
            .catch(err => alert(err))
      },

      closeWindow() {
        this.$emit('close-window', false)
      },

      addDatePickerWatcher() {
        // нужен для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

        this.$watch(
            () => {
              return this.$refs.datePicker.userInput
            },
            (newVal, oldVal) => {
              let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
              if (tmpValueForDatePicker) {
                this.date = tmpValueForDatePicker;
                this.$refs.datePicker.popupVisible = false;
              } else if (tmpValueForDatePicker === null) {
                this.$refs.datePicker.userInput = '';
                this.$refs.datePicker.currentValue = null;
              }
            }
        );
      }
    },

    mounted() {
      this.addDatePickerWatcher();
    }
  }
</script>
